import React, { useEffect, useState } from "react";
import StepperAmlCheck from "../../components/StepperAmlCheck";
import { useParams } from "react-router-dom";
import axios from "axios";
import ImageLoading from "../../components/ImageLoading";

function KycLookup() {
  const token = localStorage.getItem("token");
  const { id } = useParams();
  const [imageLoading, setImageLoading] = useState(false);
  const [data, setData] = useState([]);
  const [kycOptions, setKycOptions] = useState("personal");
  const [timelineData, setTimelineData] = useState([]);
  const fetchUsersDetails = async (controller) => {
    setImageLoading(true);
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users/${id}`,
        options
      );
      if (res.data.user_detail) {
        setData(res.data.user_detail);
      } else {
        setData([]);
      }

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const getUserDetails = async () => {
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users/${id}/aml_status_history`,
        options
      );
      setTimelineData(res?.data?.version_changes);
    } catch (error) {
      setTimelineData([]);
    }
  };

  useEffect(() => {
    const signal = new AbortController();
    fetchUsersDetails(signal);
  }, []);

  useEffect(() => {
    getUserDetails();
  }, []);
  return (
    <div className=" w-full justify-start py-3 px-4  ">
      {imageLoading && (
        <div className=" flex justify-center items-center w-full h-full">
          <ImageLoading />
        </div>
      )}
      {!imageLoading && (
        <>
          <div className="flex justify-between items-center mt-4 rounded-lg w-fit bg-[#F4F4F4] py-0.5  h-[32px]">
            <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "personal" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("personal")}
            >
              Personal Details
            </button>
            <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "bank" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("bank")}
            >
              Bank Details
            </button>
            <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "aml" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("aml")}
            >
              AML Timeline
            </button>
            {/* <button
              className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                kycOptions === "od" ? "bg-white rounded" : ""
              }`}
              onClick={() => setKycOptions("od")}
            >
              OD Timeline
            </button> */}
          </div>
          <div className="flex mt-3 text-sm">
            {kycOptions === "personal" ? (
              <div className=" rounded-lg border border-[#e2ecff] p-6 w-[350px]">
                <p className=" w-full pb-4 border-b border-[#e2ecff] font-semibold">
                  Personal Details
                </p>
                <div className="flex text-xs mt-4 justify-between">
                  <p className="flex flex-col w-[50%]">
                    <span className=" text-[#8b8b8b]  ">Name</span>
                    <span className="text-sm font-semibold">
                      {data.name || "---"}
                    </span>
                  </p>
                  <p className="flex flex-col w-[100px] text-left">
                    <span className=" text-[#8b8b8b] whitespace-nowrap">
                      Date of Birth
                    </span>
                    <span className="text-sm font-semibold whitespace-nowrap">
                      {data.dob || "---"}
                    </span>
                  </p>
                </div>
                <div className="flex text-xs mt-[13px] justify-between">
                  <p className="flex flex-col">
                    <span className=" text-[#8b8b8b]  ">Phone</span>
                    <span className="text-sm font-semibold">
                      {data.phone || "---"}
                    </span>
                  </p>
                  <p className="flex flex-col w-[100px] text-left">
                    <span className=" text-[#8b8b8b]  ">Aadhar number</span>
                    <span className="text-sm font-semibold">
                      {data.aadhar || "---"}
                    </span>
                  </p>
                </div>
                <div className="flex text-xs mt-[13px] justify-between">
                  <p className="flex flex-col">
                    <span className=" text-[#8b8b8b]  ">Email</span>
                    <span className="text-sm font-semibold">
                      {data.email?.includes(",")
                        ? data.email.split(",").map((email) => <p>{email}</p>)
                        : data.email || "---"}
                    </span>
                  </p>
                </div>
              </div>
            ) : kycOptions === "bank" ? (
              <div className=" rounded-lg border border-[#e2ecff] p-6 w-[350px]">
                <p className=" w-full pb-4 border-b border-[#e2ecff] font-semibold">
                  Bank Details
                </p>
                <div className="flex text-xs mt-4 justify-between">
                  <p className="flex flex-col w-[130px]">
                    <span className=" text-[#8b8b8b]  ">
                      Bank account number
                    </span>
                    <span className="text-sm font-semibold">
                      {data.account_number?.includes(",")
                        ? data.account_number
                            .split(",")
                            .map((bank_account) => (
                              <p className=" mt-[1px]">{bank_account}</p>
                            ))
                        : data.account_number || "---"}
                    </span>
                  </p>
                  <p className="flex flex-col w-[110px] text-left">
                    <span className=" text-[#8b8b8b]  ">IFSC code</span>
                    <span className="text-sm font-semibold">
                      {data.ifsc?.includes(",")
                        ? data.ifsc
                            .split(",")
                            .map((ifsc_code) => (
                              <p className=" mt-[1px]">{ifsc_code}</p>
                            ))
                        : data.ifsc || "---"}
                    </span>
                  </p>
                </div>
                <div className="flex text-xs mt-[13px] justify-between">
                  <p className="flex flex-col w-[30%] text-left">
                    <span className=" text-[#8b8b8b]">PAN number</span>
                    <span className="text-sm font-semibold">
                      {data.pan_number || "---"}
                    </span>
                  </p>
                </div>
              </div>
            ) : kycOptions === "aml" ? (
              <div className="border border-solid border-[#E6EBED] px-4 pt-1 py-4 rounded-lg w-[382px] h-full">
                <div className="mt-3 flex justify-between items-center">
                  <p className="text-sm font-semibold text-[#262626]">
                    AML Timeline
                  </p>
                </div>
                <div className="mt-3 h-[1px] w-full border border-solid border-[#F4F4F4]"></div>
                <div className="h-full mt-[2px]">
                  <StepperAmlCheck timeline={timelineData} />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default KycLookup;
